import * as angular from 'angular';

export class PeriodicTasksFactory {
    private apiRoot: string = '/api/v1/periodic_tasks';
    private $http;

    constructor($http) {
        this.$http = $http;
    }

    create(value) {
        return this.$http.post(`${this.apiRoot}/`, value);
    };

    read() {
        return this.$http.get(`${this.apiRoot}/`);
    };

    readOne(id) {
        return this.$http.get(`${this.apiRoot}/${id}/`);
    };

    update(id, value) {
        return this.$http.put(`${this.apiRoot}/${id}/`, value);
    };

    delete(id) {
        return this.$http.delete(`${this.apiRoot}/${id}/`);
    };
}

angular
    .module('app')
    .service('PeriodicTasksFactory', PeriodicTasksFactory);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/periodic_tasks.factory.ts